import React from 'react';
import { useSelector } from 'react-redux';
import DayPageShell from './DayPageShell';
import McqGame from '../McqGame';
import { s3PublicUrl } from '../../../utils/s3PublicUrl';

export default function Day4({ onStageComplete }) {
  const themeData = useSelector((state) => state.theme.data);
  const stage4 = themeData?.stages_data?.stage_4;
  const questions = stage4?.questions;
  const badgeUrl = s3PublicUrl(stage4?.badge);
  const pointsIconUrl = s3PublicUrl(themeData?.points_icon);
  const correctPoints = themeData?.correct_points ?? 0;
  const dayBonusPoints = themeData?.bonus_points ?? 0;

  const isConfigured =
    stage4 &&
    (stage4.type === 'lateral_thinking' || stage4.type === 'mcq') &&
    Array.isArray(questions) &&
    questions.length > 0;

  return (
    <DayPageShell dayNumber={4} className="main-day-view--immersive main-day-view--day4-mcq">
      {!isConfigured ? (
        <p className="main-day-subtitle">
          MCQ stage is not configured: add stage_4 questions with options, answer, and did_you_know.
        </p>
      ) : (
        <McqGame
          questions={questions}
          rules={stage4.rules}
          badgeUrl={badgeUrl}
          badgeTitle={String(stage4?.title ?? stage4?.name ?? 'Day 4')}
          questionImage={String(stage4?.question_image ?? '')}
          didYouKnowImage={String(stage4?.did_you_know_image ?? '')}
          correctPoints={correctPoints}
          dayBonusPoints={dayBonusPoints}
          pointsIconUrl={pointsIconUrl}
          badgeFallbackLabel="Day 4"
          onComplete={onStageComplete}
        />
      )}
    </DayPageShell>
  );
}
